import { IFetchOptions } from "itsf-ui-common";
import { fetcher } from "@utils/fetcher";
import { ICart } from "@features/cart/ICart";
import { deleteOfferRoute } from "@api-routes/eirSalesFacade";
import { getResponseToState } from "@mappers/getCartMapper";

export const deleteOffer = (offerId: number, options: IFetchOptions = {}) => {
    return fetcher<ICart>(deleteOfferRoute(offerId), {
        ...options,
        method: "DELETE",
        mapper: getResponseToState,
    });
};
